import { render, staticRenderFns } from "./BusinessPartners.vue?vue&type=template&id=6ab5e273&scoped=true"
import script from "./BusinessPartners.vue?vue&type=script&lang=ts"
export * from "./BusinessPartners.vue?vue&type=script&lang=ts"
import style0 from "./BusinessPartners.vue?vue&type=style&index=0&id=6ab5e273&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab5e273",
  null
  
)

export default component.exports